import styled from "styled-components";

export const NodeStatusRendrerStyled = styled.span`
  &.node-status-rendrer {
    display: flex;
  }
`;
